<template>
<svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-psm-shuaxin`]" width="1em" height="1em" v-bind="$attrs"><g :fill="useCurrentColor ? 'currentColor' : '#1D2129'" fill-rule="nonzero"><path d="M49.7840996,-5 C72.0601152,-5 91.8546513,8.22852202 100.320563,28.1182525 L100.573629,28.7230037 L91.3254056,32.5269963 C84.5419636,16.0351688 68.2152832,5 49.7840996,5 C25.0315313,5 5,24.7160347 5,49 C5,73.2839653 25.0315313,93 49.7840996,93 C70.1485298,93 87.76714,79.5306911 93.0076662,60.5614893 L93.1626713,59.9849897 L102.837329,62.5150103 C96.6475396,86.1844187 74.9060548,103 49.7840996,103 C19.5439068,103 -5,78.8426597 -5,49 C-5,19.1573403 19.5439068,-5 49.7840996,-5 Z" transform="translate(16 16)"/><path d="M103 0L103 34.4 68.6 34.4 68.6 24.4 92.999 24.4 93 0z" transform="translate(16 16)"/></g></svg>
</template>
<script>

export default {
  name: 'IconPsmShuaxin',
  props: {
    prefix: {
        type: String,
        default: 'psm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
